export default __webpack_public_path__ + "static/media/python-seeklogo.com.e9751126.svg";